<template>
    <LayoutBase>
        <div class="full-height grid">
            <div id="content-wrapper" class="app-position">
                <div class="container-fluid">
                    <div class="row no-gutters">
                        <div class="col-2"></div>
                        <div class="col-8">
                            <div class="article-wrapper">
                                <alert v-if="alert.copy" :type="alert.type" :title="alert.title" :copy="alert.copy"></alert>

                                <div class="panel">
                                    <header>
                                        <h1>Change password</h1>
                                    </header>

                                    <div class="form">
                                        <p>Your password must be a minimum of 8 characters</p>
                                        <div class="form__group">
                                            <label class="form__label" for="password">New password</label>
                                            <input type="password" id="password" name="password" class="form__control" v-model="user.password">
                                        </div>

                                        <div class="form__group">
                                            <label class="form__label" for="password_confirmation">Confirm new password</label>
                                            <input type="password" id="password_confirmation" name="password_confirmation" class="form__control" v-model="user.password_confirmation" >
                                        </div>

                                        <div class="form__group">
                                            <button class="btn btn-primary" v-on:click.stop.prevent="saveSettings">Save Password</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-2"></div>
                    </div>
                </div>
            </div>
        </div>
    </LayoutBase>
</template>

<script>
    import LayoutBase from '../../layouts/LayoutBase';

    export default {
        components: {
            LayoutBase
        },
        data () {
            return {
                alert: {
                    type: null,
                    title: null,
                    copy: null
                },
                user: {
                    password : null,
                    password_confirmation: null
                },
            }
        },
        mounted() {

        },
        methods: {
            saveSettings(){
                axios.put('/api/user/change-password', this.user).then((response) => {
                    this.user.password = null;
                    this.user.password_confirmation = null;
                    
                    window.scrollTo(0, 0);
                    this.alert.type = 'success';
                    this.alert.copy = ["Your password has been updated"];
                }).catch(error => {
                    window.scrollTo(0, 0);
                    this.alert.type = 'error';
                    this.alert.copy = error.response.data.errors;
                });
            }
        },
        // // Guard to protect route from none admins
        // beforeRouteEnter(to, from, next){
        //     if (!window.user_can.admin) next('/')
        //     else next()
        // }
    }
</script>
